import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["main"];
  static values = { loginSrc: String };

  connect() {
    this.boundHandleTurboResponse = this.handleTurboResponse.bind(this);
    this.boundHideProgressBar = this.hideProgressBar.bind(this);
    this.boundCheckSrc = this.checkSrc.bind(this);

    document.addEventListener("turbo:before-fetch-response", this.boundHandleTurboResponse);
    document.addEventListener("hide-progress-bar", this.boundHideProgressBar);

    if (this.hasLoginSrcValue) {
      this.open(this.loginSrcValue);
    }
  }

  disconnect() {
    document.removeEventListener("turbo:before-fetch-response", this.boundHandleTurboResponse);
    document.removeEventListener("hide-progress-bar", this.boundHideProgressBar);
  }

  checkSrc() {
    if (this.element.dataset.loginSrc) {
      this.open(this.element.dataset.loginSrc);
    }
  }

  // ##############
  hideProgressBar() {
    const adapter = window.Turbo?.navigator?.adapter;
    setTimeout(() => {
      if (adapter && adapter.progressBar) {
        adapter.progressBar.hide();
      }
    }, 500);
  }

  hideProgressBarEvent() {
    const event = new CustomEvent('hide-progress-bar');
    document.dispatchEvent(event);
  }

  // ##############

  handleTurboResponse(event) {
    const fetchResponse = event.detail && event.detail.fetchResponse;
    const response = fetchResponse && fetchResponse.response;
    if (!response) return;


    const action = response.headers.get("X-Trigger-Stimulus");
    if (!action) return;

    // Prevent Turbo from following/completing the visit so we stay on the current page
    event.preventDefault();
    // Explicitly cancel any deferred continuation Turbo might try to resume
    if (event.detail) event.detail.resume = null;

    if (action === "login#openLogin") {
      this.openLogin();
    } else if (action === "login#openSignup") {
      this.openSignup();
    } else if (action === "login#close") {
      this.close();
    }
  }

  openLogin() {
    this.open("/quick_signup/login");
  }

  openSignup() {
    this.open("/quick_signup/new");
  }

  open(path) {
    if (document.querySelector("#login_modal")) {
      return;
    }

    const frame = document.createElement("turbo-frame")
    frame.id = "login_modal"
    frame.src = path || "/quick_signup/login"
    frame.classList.add("loginmodal")
    frame.style.display = "none"
    frame.style.transition = "all 1s ease"
    document.body.appendChild(frame)

    requestAnimationFrame(() =>
      setTimeout(() => {
        frame.style.display = "block";
      })
    );

    this.hideProgressBarEvent();
  }

  close() {
    window.history.replaceState({}, document.title, window.location.pathname);
    document.querySelector("#login_modal")?.remove()
  }
}
